import { createPortal } from 'react-dom';
import { getPhotoUrl } from '../lib/api.js';

// Attachment preview modal — rendered via Portal directly to document.body
// to completely bypass any CSS stacking context / overflow / z-index issues
function AttachmentPreviewModal({ attachment, onClose }) {
  if (!attachment) return null;
  const url = getPhotoUrl(attachment);
  const isPdf = typeof attachment === 'string'
    ? attachment.toLowerCase().endsWith('.pdf')
    : (attachment instanceof File && (attachment.type === 'application/pdf' || attachment.name.toLowerCase().endsWith('.pdf')));
  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.88)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 2147483647,
        padding: '16px',
      }}
    >
      <div onClick={e => e.stopPropagation()} style={{ position: 'relative', maxWidth: '95vw', maxHeight: '95vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: '-44px', right: '0',
            background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '50%', width: '36px', height: '36px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', color: 'white', zIndex: 1,
          }}
        >
          <span style={{ fontSize: '18px', lineHeight: 1 }}>✕</span>
        </button>
        {isPdf ? (
          <iframe
            src={url}
            style={{ width: '85vw', height: '85vh', border: 'none', background: 'white', borderRadius: '8px' }}
            title="Attachment"
          />
        ) : (
          <img
            src={url}
            alt="Attachment"
            style={{ maxWidth: '90vw', maxHeight: '88vh', objectFit: 'contain', borderRadius: '8px', display: 'block' }}
          />
        )}
      </div>
    </div>,
    document.body
  );
}

export default AttachmentPreviewModal;
